import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './authentication/login-page/login-page.component';
import { LaunchPageComponent } from './launch/launch-page/launch-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './auth/interceptor';
import { AuthService } from './auth/auth.service';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthGuard } from './auth/auth.guards';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CommonService } from './services/common.service';
import {MatNativeDateModule} from '@angular/material/core';
import { MaterialModule } from './shared/material.module';
import * as config from './app.config';
import { StoreModule } from '@ngrx/store';
import { SharedService } from './shared/services/shared.service';
import { reducers } from './ngrx/reducers';
import { TextInputAutocompleteModule } from 'angular-text-input-autocomplete';
import { AgGridModule } from 'ag-grid-angular';
import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { GoogleMapsModule } from '@angular/google-maps';
import { WalktestLaunchPageComponent } from './launch/walktest-launch-page/walktest-launch-page';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    LaunchPageComponent,
    WalktestLaunchPageComponent
  ],
  imports: [
    BrowserModule,
    // FontAwesomeModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    SharedModule,
    RouterModule,
    HttpClientModule,
    NgApexchartsModule,
    MatNativeDateModule,
    MaterialModule,
    AgGridModule,
    AgmCoreModule,
    GoogleMapsModule,
    CarouselModule,
    NgSelectModule,
    StoreModule.forRoot(reducers),
    TextInputAutocompleteModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),

  ],
  providers: [SharedService,
    AuthService,AuthGuard,CommonService,
   { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
   {
    provide: 'apiEndPoint',
    useValue: config.API_END_POINT
  },
  {
    provide: 'upgradeEndPoint',
    useValue: config.UPGRADE_URL
  },
  {
    provide: 'iperfServerUrl',
    useValue: config.IPERFURL
  },
  {
    provide: 'topologyEndPoint',
    useValue: config.TOPOLOGY
  },
  {
    provide: 'version',
    useValue: config.VERSION_INFO
  },
  {
    provide: 'edgeEndPoint',
    useValue: config.EDGEURL
  },
  {
    provide: 'edgeAPIEndPoint',
    useValue: config.EDGEAPIURL
  },
  {
    provide: 'pciAPIEndPoint',
    useValue: config.PCIAPIURL
  },
  {
    provide: 'fileServerUrl',
    useValue: config.FILESERVERURL
  },
  {
    provide: 'logfileServerUrl',
    useValue: config.LOGFILESERVERURL
  },
  {
    provide: 'rulesEngineUrl',
    useValue: config.RULESENGINEURL
  },
  {
    provide: 'googleMapApi',
    useValue: config.GOOGLEAPI
  },
  {
    provide: 'mlServerUrl',
    useValue: config.MLSERVERURL
  },
  {
    provide: 'diagnosticUrl',
    useValue: config.DIAGNOSTICURL
  },
  {
    provide: 'userGuideFileName',
    useValue: config.userGuideFileName
  },
  {
    provide: 'gpsServerUrl',
    useValue: config.gpsUrl
  },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
